export class VideoPokerApiError extends Error {
  constructor(message, code = "VIDEO_POKER_REQUEST_FAILED", status = 500) {
    super(message);
    this.name = "VideoPokerApiError";
    this.code = code;
    this.status = status;
  }
}

async function readJsonResponse(response) {
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new VideoPokerApiError(
      payload?.error || "Video Poker request failed",
      payload?.code || "VIDEO_POKER_REQUEST_FAILED",
      response.status
    );
  }

  return payload;
}

export async function getVideoPokerProfile() {
  const response = await fetch("/api/user/profile", {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });

  return readJsonResponse(response);
}

export async function getActiveVideoPokerRound() {
  const response = await fetch("/api/video-poker/active", {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });

  return readJsonResponse(response);
}

export async function dealVideoPokerRound(bet) {
  const response = await fetch("/api/video-poker/deal", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ bet }),
  });

  return readJsonResponse(response);
}

export async function drawVideoPokerRound(roundId, heldIndices) {
  const response = await fetch("/api/video-poker/draw", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ roundId, heldIndices }),
  });

  return readJsonResponse(response);
}
